import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk'; // Correct way to import it
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import asyncReducer from "../Reducer/reducer";

const persistConfig = {
    key: 'root',
    storage: storage
};

const persistedReducer = persistReducer(persistConfig, asyncReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };
